import { ActivityFeedEventName } from '../enums/activity-feed-event-name.enum';

export interface ActivityFeedEventDisplay {
  /** Rendered as a muted suffix so events belonging to one process read as a group. */
  group?: string;
  label: string;
}

const applicationGroup = 'Application';

const eventDisplayMap = new Map<ActivityFeedEventName, ActivityFeedEventDisplay>([
  [ActivityFeedEventName.APPLICATION_SENT, { group: applicationGroup, label: 'Invite sent' }],
  [ActivityFeedEventName.APPLICATION_REQUESTED, { group: applicationGroup, label: 'Requested to apply' }],
  [ActivityFeedEventName.APPLICATION_STARTED, { group: applicationGroup, label: 'Started' }],
  [ActivityFeedEventName.CO_APPLICANT_INVITED, { group: applicationGroup, label: 'Co-applicant invited' }],
  [ActivityFeedEventName.CO_SIGNER_INVITED, { group: applicationGroup, label: 'Co-signer invited' }],
  [ActivityFeedEventName.APPLICANT_REMOVED, { group: applicationGroup, label: 'Applicant removed' }],
  [ActivityFeedEventName.SCREENING_FEE_PAID, { group: applicationGroup, label: 'Screening fee paid' }],
  [ActivityFeedEventName.BACKGROUND_CHECK_COMPLETED, { group: applicationGroup, label: 'Background check completed' }],
  [ActivityFeedEventName.APPLICATION_READY_TO_SUBMIT, { group: applicationGroup, label: 'Ready to submit' }],
  [ActivityFeedEventName.APPLICATION_COMPLETED, { group: applicationGroup, label: 'Submitted' }],
  [ActivityFeedEventName.APPLICATION_APPROVED, { group: applicationGroup, label: 'Approved' }],
  [ActivityFeedEventName.APPLICATION_DECLINED, { group: applicationGroup, label: 'Declined' }],
  [ActivityFeedEventName.APPLICATION_UPDATE_REQUESTED, { group: applicationGroup, label: 'More info requested' }],
  [ActivityFeedEventName.APPLICATION_RESUBMITTED, { group: applicationGroup, label: 'Resubmitted' }],
]);

/**
 * Ungrouped events fall back to the enum value, which is already human-readable - so an event added
 * to the backend without a display entry renders plainly rather than blank.
 */
export function getActivityFeedEventDisplay(eventName: ActivityFeedEventName): ActivityFeedEventDisplay {
  return eventDisplayMap.get(eventName) ?? { label: eventName };
}
